import axios from 'axios'
import getMeta from 'lets-get-meta'
import store from './vuex/store'
class Scraper {
  constructor (url) {
    this.url = url
  }
  getContent () {
    axios.get(`http://of-scraper.us-east-1.elasticbeanstalk.com/?url=${this.url}`)
      .then(res => {
        this.meta = getMeta(res.data.contents)
        this.content = res.data.contents
        this.retrieveData()
      })
  }
  retrieveData () {
    let metas = {
      title: this.getTitle(),
      description: this.getDescription(),
      image: this.meta['og:image']
    }
    store.dispatch('addScraperData', metas)
  }
  getTitle () {
    if (this.meta.hasOwnProperty('og:title')) {
      return this.meta['og:title']
    } else if (this.meta.hasOwnProperty('twitter:title')) {
      return this.meta['twitter:title']
    } else if (this.content.match(/<title[^>]*>([^<]+)<\/title>/)[1]) {
      return this.content.match(/<title[^>]*>([^<]+)<\/title>/)[1]
    } else return ''
  }
  getDescription () {
    if (this.meta.hasOwnProperty('og:description')) {
      return this.meta['og:description']
    } else if (this.meta.hasOwnProperty('twitter:description')) {
      return this.meta['twitter:description']
    } else if (this.meta['description']) {
      return this.meta['description']
    } else return ''
  }
}

export default Scraper
